<template>
  <div v-if="company">
    <company-details
      :company.sync="company"
      class="mt-3"
      @syncOffer="syncOffer"
      @update:datacompany="syncOffer"
      @reloadCompany="syncOffer"
    />
    <company-owner :company.sync="company" class="mt-3" />
    <company-documents :company.sync="company" class="mt-3" />
    <individual-mobile-money-details class="mt-2" :owner="company.owner" />
    <individual-bank-details class="mt-2" :owner="company.owner" />
    <company-networks :company.sync="company" class="mt-2" />
    <company-agents :company.sync="company" class="mt-2" />
  </div>
</template>
<script>
/* eslint-disable */
import CompanyDetails from "./cards/details";
import CompanyOwner from "./cards/owner";
import CompanyDocuments from "./cards/documents";
import CompanyNetworks from "./networks";
import CompanyAgents from "./agents";
import IndividualBankDetails from "@/app/accounts/bankaccounts/all.vue";
import IndividualMobileMoneyDetails from "@/app/accounts/mobilemoney/all.vue";

export default {
  components: {
    CompanyDetails,
    CompanyOwner,
    CompanyAgents,
    CompanyNetworks,
    CompanyDocuments,
    IndividualBankDetails,
    IndividualMobileMoneyDetails,
  },
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      company: null,
    };
  },
  methods: {
    syncOffer() {
      this.fetchData();
    },
    fetchData() {
      this.$http.get(`api/v1/companies/${this.id}`).then((company) => {
        this.company = company;
      });
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
